"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Preloader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react = _interopRequireWildcard(require("react"));
var _colors = require("../../constants/colors");
var _PreloaderContainer = require("./components/PreloaderContainer");
const DURATION_MS = 3150;
const TIMING_FUNCTION_A = "cubic-bezier(1.00, 0.00, 0.83, 0.83)";
const TIMING_FUNCTION_B = "cubic-bezier(0.17, 0.17, 0.00, 1.00)";

/*
 * This preloader animation cycles between 3 "states", pausing for "interval" on each one.
 * The animation begins (keyframe 0%) showing the first state, exactly midway through the
 * interval for that state. From there, keyframes define the end of that interval, the
 * beginnings and endings of all other intervals, and the midpoints of each state transition.
 * The last keyframe should define the beginning of the first interval, for seamless looping.
 *
 * The midpoint keyframes are used to guide animation of elements to in-between positions as
 * needed so state transitions aren't direct interpolations; two different timing functions
 * (defined above) are used before and after midpoints to create smoother easing motion
 * without noticeably pausing at the midpoints.
 */

const keyframePercentages = {
  // tableFullyVisible: 0,0 <-- unecessary, 0/100 values are the component's default styles.
  midpointTableGantt: 16.66,
  // 0.525s
  ganttFullyVisible: 33.33,
  // 1.05s
  midpointGanttCard: 50.0,
  // 1.575s
  cardFullyVisible: 66.66,
  // 2.10s
  midpointCardTable: 83.33 // 2.625s
};

const Background = (0, _styled.default)("rect")`
    fill: #223a57;
    width: 96px;
    height: 96px;
    x: 0;
    y: 0;
`;
const BaseAnimatedRect = (0, _styled.default)("rect")`
    fill: ${_colors.neutralLight40};
    animation: ${DURATION_MS}ms infinite;
    animation-timing-function: ${TIMING_FUNCTION_A};
`;
const rect1AnimationName = (0, _core.keyframes)`
    ${keyframePercentages.midpointTableGantt}% {
        width: 8px;
        height: 12px;
        x: 64px;
        y: 25px;
        opacity: 0;
    }
    ${keyframePercentages.midpointGanttCard}% {
        width: 21px;
        height: 3px;
        x: 24px;
        y: 76px;
        opacity: 0;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
    ${keyframePercentages.cardFullyVisible}% {
        height: 12px;
        y: 59px;
        opacity: 1;
        animation-timing-function: ${TIMING_FUNCTION_A};
    }
    ${keyframePercentages.midpointCardTable}% {
        width: 21px;
        y: 25px;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
`;
const Rect1 = (0, _styled.default)(BaseAnimatedRect)`
    animation-name: ${rect1AnimationName};
    width: 48px;
    height: 12px;
    x: 24px;
    y: 25px;
    opacity: 1;
`;
const rect2AnimationName = (0, _core.keyframes)`
    ${keyframePercentages.midpointTableGantt}% {
        width: 10px;
        y: 25px;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
    ${keyframePercentages.ganttFullyVisible}% {
        width: 33px;
        x: 24px;
        animation-timing-function: ${TIMING_FUNCTION_A};
    }
    ${keyframePercentages.midpointGanttCard}% {
        width: 21px;
        height: 12px;
        x: 51px;
        y: 25px;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
    ${keyframePercentages.cardFullyVisible}% {
        height: 29px;
        y: 42px;
        opacity: 1;
        animation-timing-function: ${TIMING_FUNCTION_A};
    }
    ${keyframePercentages.midpointCardTable}% {
        width: 21px;
        height: 3px;
        x: 51px;
        y: 76px;
        opacity: 0;
    }
    // Fancy math to quickly move this to its next starting position as soon as possible.
    ${keyframePercentages.midpointCardTable + 0.01}% {
        width: 3px;
        height: 12px;
        x: 24px;
        y: 42px;
        opacity: 0;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
`;
const Rect2 = (0, _styled.default)(BaseAnimatedRect)`
    animation-name: ${rect2AnimationName};
    width: 10px;
    height: 12px;
    x: 24px;
    y: 42px;
    opacity: 1;
`;
const rect3AnimationName = (0, _core.keyframes)`
    ${keyframePercentages.midpointTableGantt}% {
        width: 15px;
        height: 3px;
        x: 38px;
        y: 34px;
        opacity: 0;
        animation-timing-function: linear;
    }
    ${keyframePercentages.midpointCardTable}% {
        width: 3px;
        height: 12px;
        x: 24px;
        y: 42px;
        opacity: 0;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
`;
const Rect3 = (0, _styled.default)(BaseAnimatedRect)`
    animation-name: ${rect3AnimationName};
    width: 15px;
    height: 12px;
    x: 38px;
    y: 42px;
    opacity: 1;
`;
const rect4AnimationName = (0, _core.keyframes)`
    ${keyframePercentages.midpointTableGantt}% {
        width: 15px;
        x: 57px;
        y: 59px;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
    ${keyframePercentages.ganttFullyVisible}% {
        width: 33px;
        x: 39px;
        animation-timing-function: ${TIMING_FUNCTION_A};
    }
    ${keyframePercentages.midpointGanttCard}% {
        width: 21px;
        height: 12px;
        x: 24px;
        y: 59px;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
    ${keyframePercentages.cardFullyVisible}% {
        width: 21px;
        height: 29px;
        y: 25px;
        opacity: 1;
        animation-timing-function: ${TIMING_FUNCTION_A};
    }
    ${keyframePercentages.midpointCardTable}% {
        width: 21px;
        height: 3px;
        x: 24px;
        y: 17px;
        opacity: 0;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
    // Fancy math to quickly move this to its next starting position as soon as possible.
    ${keyframePercentages.midpointCardTable + 0.01}% {
        width: 3px;
        height: 12px;
        x: 77px;
        y: 42px;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
`;
const Rect4 = (0, _styled.default)(BaseAnimatedRect)`
    animation-name: ${rect4AnimationName};
    width: 15px;
    height: 12px;
    x: 57px;
    y: 42px;
    opacity: 1;
`;
const rect5AnimationName = (0, _core.keyframes)`
    ${keyframePercentages.midpointTableGantt}% {
        width: 10px;
        height: 3px;
        x: 24px;
        y: 42px;
        opacity: 0;
    }
    ${keyframePercentages.midpointGanttCard}% {
        width: 21px;
        height: 3px;
        x: 51px;
        y: 24px;
        opacity: 0;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
    ${keyframePercentages.cardFullyVisible}% {
        height: 12px;
        y: 25px;
        opacity: 1;
        animation-timing-function: ${TIMING_FUNCTION_A};
    }
    ${keyframePercentages.midpointCardTable}% {
        width: 21px;
        x: 51px;
        y: 59px;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
`;
const Rect5 = (0, _styled.default)(BaseAnimatedRect)`
    animation-name: ${rect5AnimationName};
    width: 10px;
    height: 12px;
    x: 24px;
    y: 59px;
    opacity: 1;
`;
const rect6AnimationName = (0, _core.keyframes)`
    ${keyframePercentages.midpointTableGantt}% {
        width: 15px;
        x: 38px;
        y: 42px;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
    ${keyframePercentages.ganttFullyVisible}% {
        width: 33px;
        x: 32px;
        opacity: 1;
        animation-timing-function: ${TIMING_FUNCTION_A};
    }
    ${keyframePercentages.midpointGanttCard}% {
        width: 3px;
        x: 46.5px;
        y: 42px;
        opacity: 0;
    }
    ${keyframePercentages.midpointCardTable}% {
        width: 3px;
        x: 74px;
        y: 59px;
        opacity: 0;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
`;
const Rect6 = (0, _styled.default)(BaseAnimatedRect)`
    animation-name: ${rect6AnimationName};
    width: 15px;
    height: 12px;
    x: 38px;
    y: 59px;
    opacity: 1;
`;
const rect7AnimationName = (0, _core.keyframes)`
    ${keyframePercentages.midpointTableGantt}% {
        height: 3px;
        y: 71px;
        opacity: 0;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
    ${keyframePercentages.midpointCardTable}% {
        width: 3px;
        height: 12px;
        x: 77px;
        y: 59px;
        opacity: 0;
        animation-timing-function: ${TIMING_FUNCTION_B};
    }
`;
const Rect7 = (0, _styled.default)(BaseAnimatedRect)`
    animation-name: ${rect7AnimationName};
    width: 15px;
    height: 12px;
    x: 57px;
    y: 59px;
    opacity: 1;
`;
const Preloader = _ref => {
  let {
    clientId,
    initialDelay,
    size = 96,
    ...rest
  } = _ref;
  const [showLoader, setShowLoader] = (0, _react.useState)(initialDelay === undefined);
  (0, _react.useEffect)(() => {
    if (!showLoader && initialDelay && initialDelay > 0) {
      const timeout = setTimeout(() => {
        setShowLoader(true);
      }, initialDelay);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [initialDelay, showLoader]);
  return /*#__PURE__*/_react.default.createElement(_PreloaderContainer.PreloaderContainer, (0, _extends2.default)({
    "data-client-id": clientId,
    sideLength: size
  }, rest), showLoader && /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 96 96"
  }, /*#__PURE__*/_react.default.createElement(Background, {
    rx: "7",
    ry: "7"
  }), /*#__PURE__*/_react.default.createElement(Rect1, {
    rx: "2",
    ry: "2"
  }), /*#__PURE__*/_react.default.createElement(Rect2, {
    rx: "2",
    ry: "2"
  }), /*#__PURE__*/_react.default.createElement(Rect3, {
    rx: "2",
    ry: "2"
  }), /*#__PURE__*/_react.default.createElement(Rect4, {
    rx: "2",
    ry: "2"
  }), /*#__PURE__*/_react.default.createElement(Rect5, {
    rx: "2",
    ry: "2"
  }), /*#__PURE__*/_react.default.createElement(Rect6, {
    rx: "2",
    ry: "2"
  }), /*#__PURE__*/_react.default.createElement(Rect7, {
    rx: "2",
    ry: "2"
  })));
};
exports.Preloader = Preloader;
//# sourceMappingURL=Preloader.js.map